import React from 'react';
import {Link, useLocation} from "react-router-dom";
import HelpIcon from "components/icons/HelpIcon";
import CogwheelIcon from "components/icons/CogwheelIcon";
import classnames from "classnames";
import usePathnameWithNoLangCode from "hooks/usePathnameWithNoLangCode";

const CSS = require('./AgendaBottomBar.less');

function AgendaBottomBar() {
  const location = useLocation();
  const pathname = usePathnameWithNoLangCode();

  return (
    <nav className={CSS.AgendaBottomBar}>
      <Link to={{...location, pathname: '/host-agenda/create-event/'}} className={CSS.TextLink}>
        Create Event
      </Link>
      <Link to={{...location, pathname: '/host-agenda/onboarding/'}} className={classnames(CSS.IconLink, { [CSS.ActiveIconLink]: pathname?.includes('/host-agenda/onboarding/') })}>
        <HelpIcon width={24} height={24} className={CSS.Icon} />
      </Link>
      <Link to={{...location, pathname: '/host-agenda/settings/'}} className={classnames(CSS.IconLink, { [CSS.ActiveIconLink]: pathname?.includes('/host-agenda/settings/') })}>
        <CogwheelIcon width={24} height={24} className={CSS.Icon} />
      </Link>
    </nav>
  );
}

export default AgendaBottomBar;
